
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDiodes06On as ObiDiodes06OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-diodes-06-on.js';
 
 
 

 
 export const ObiDiodes06On = createComponent({
   react: React,
   tagName: 'obi-diodes-06-on',
   elementClass: ObiDiodes06OnElement,
   events: {
     
   }
  });
 
 